import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import ServicesReceived2 from "../Forms/K/ServicesReceived/ServicesReceived2"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const ServicesReceived2Container = ({
  showToolBar,
  disabled,
  interview_id,
}) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)
  const [isGettingServicesReceived, setIsGettingServicesReceived] =
    useState(true)

  const toast = useRef()

  useEffect(() => {
    setIsGettingServicesReceived(true)
    if (interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id) {
      handleSubmitGet(endpoints.GET_SERVICESRECEIVED_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_2,
      })
        .then((response) => {
          loadCollection(
            setValues(response.data),
            INTERVIEW_SECTIONS.SERVICES_RECEIVED_2
          )
          setIsGettingServicesReceived(false)
          handleLoadPrev(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          setIsGettingServicesReceived(false)
          handleLoadPrev(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_k_ts_1: data?.form?.gpraKTs1 ?? 0,
      gpra_k_ts_2: data?.form?.gpraKTs2 ?? 0,
      gpra_k_ts_3: data?.form?.gpraKTs3 ?? 0,
      gpra_k_ts_4: data?.form?.gpraKTs4 ?? 0,
      gpra_k_ts_5: data?.form?.gpraKTs5 ?? 0,
      gpra_k_ts_6: data?.form?.gpraKTs6 ?? 0,
      gpra_k_ts_7: data?.form?.gpraKTs7 ?? 0,
      gpra_k_ts_8: data?.form?.gpraKTs8 ?? 0,
      gpra_k_ts_9: data?.form?.gpraKTs9 ?? 0,
      gpra_k_ts_10: data?.form?.gpraKTs10 ?? 0,
      gpra_k_ts_11: data?.form?.gpraKTs11 ?? 0,
      gpra_k_ts_12: data?.form?.gpraKTs12 ?? 0,
      gpra_k_ts_13: data?.form?.gpraKTs13 ?? 0,
      gpra_k_ts_14: data?.form?.gpraKTs14 ?? 0,
      gpra_k_ts_15: data?.form?.gpraKTs15 ?? 0,
      gpra_k_ts_16: data?.form?.gpraKTs16 ?? 0,
      gpra_k_ts_17: data?.form?.gpraKTs17 ?? 0,
      gpra_k_ts_18: data?.form?.gpraKTs18 ?? 0,
      gpra_k_ts_18a: data?.form?.gpraKTs18a ?? "",
      gpra_k_id: data?.form?.gpraKId ?? 0,
      additional: data?.additional,
    }
  }

  if (isGettingServicesReceived) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingServicesReceived && (
        <ServicesReceived2 showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default ServicesReceived2Container
